import { css } from "styled-components";

export const pageStyle = css`
    &.aevi-page-container {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
    }

    &.aevi-page-header {
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        padding: 0 20px;
        flex-shrink: 0;
        background-color: white;
    }

    &.aevi-page-header-row {
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &.aevi-page-title {
        font-size: 18pt;
        padding: 10px 0;
    }

    &.aevi-page-content {
        padding: 15px;
        width: 100%;
        flex: 1;
        overflow-y: auto;
        min-height: 0;
    }
`;
